import axiosInstance from "src/utils/axios";

// Persists that the current user has joined the official WhatsApp group.
// TODO: confirm the final endpoint path/shape with the backend team.
const markWhatsAppGroupJoined = async () => {
  const { status, data } = await axiosInstance.post(
    "api/user/whatsapp-group/joined"
  );
  return { status, data };
};

export default markWhatsAppGroupJoined;
